import { render } from "./ImageCheck.vue?vue&type=template&id=0be49b87"
import script from "./ImageCheck.vue?vue&type=script&lang=js"
export * from "./ImageCheck.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__